import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRefund } from '../../../../../core/vendor-events/action';
import RefundsTable from './RefundsTable';

function RefundAplication({ event }) {
  const dispatch = useDispatch();
  const { eventListRefund } = useSelector((store) => store.vendorEvents);

  useEffect(() => {
    if (!event?.id) return;
    dispatch(getRefund(event.id));
  }, [dispatch, event]);

  useEffect(() => {
    console.log(eventListRefund);
  }, [eventListRefund]);

  return (
    <Grid item xs={12}>
      {eventListRefund?.length ? (
        <RefundsTable eventList={eventListRefund} />
      ) : (
        <p>There are no applications results for this event</p>
      )}
    </Grid>
  );
}

RefundAplication.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
};

export default RefundAplication;
